var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { default as AntBreadcrumb } from 'antd/lib/breadcrumb';
import { RoutesManager } from '@comall-backend-builder/core';

var Breadcrumb = function (_super) {
  __extends(Breadcrumb, _super);

  function Breadcrumb() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Breadcrumb.prototype.convertRoutes = function (pathname, originRoutes) {
    var routes = [];

    for (var _i = 0, originRoutes_1 = originRoutes; _i < originRoutes_1.length; _i++) {
      var route = originRoutes_1[_i];
      var matchRoute = {
        path: '',
        isExact: false
      };
      matchRoute.path = route.path;

      if (route.exact !== undefined) {
        matchRoute.isExact = route.exact;
      }

      var match = matchPath(pathname, matchRoute);

      if (match) {
        var breadcrumbName = route.breadcrumbName,
            childRoutes = route.childRoutes;

        if (breadcrumbName) {
          routes.push(route);
        }

        if (childRoutes) {
          if (match.url !== '/') {
            pathname = pathname.substring(match.url.length);
          }

          routes = routes.concat(this.convertRoutes(pathname, childRoutes));
        }

        break;
      }
    }

    return routes;
  };

  Breadcrumb.prototype.render = function () {
    var pathname = this.props.location.pathname;
    var routes = this.convertRoutes(pathname, RoutesManager.getRoutes());
    return React.createElement(AntBreadcrumb, __assign({}, this.props, {
      routes: routes
    }));
  };

  return Breadcrumb;
}(Component);

export { Breadcrumb };